var _defs, _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgİconLicence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #9180f9;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,2.6h-.5c-.4,0-.8.4-.8.8v13.2c0,.5.4.8.8.8h.6c.4,0,.8-.4.8-.8V3.4c0-.4-.4-.8-.8-.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,2.6c-.3,0-.5.2-.5.5v13.7c0,.3.2.6.5.6s.5-.2.5-.5V3.1c0-.3-.2-.5-.5-.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,2.6h-.5c-.4,0-.8.4-.8.8v13.2c0,.5.4.8.8.8h.6c.4,0,.8-.4.8-.8V3.4c0-.4-.4-.8-.8-.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 13.7,
    y: 2.6,
    width: 2.1,
    height: 14.8,
    rx: 0.8,
    ry: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,2.6c-.3,0-.5.2-.5.5v13.7c0,.3.2.5.5.5s.5-.2.5-.5V3.1c0-.3-.2-.5-.5-.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,2.6c-.3,0-.5.2-.5.5v13.7c0,.3.2.5.5.5s.5-.2.5-.5V3.1c0-.3-.2-.5-.5-.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,2.6c-.3,0-.5.2-.5.5v13.7c0,.3.2.5.5.5s.5-.2.5-.5V3.1c0-.3-.2-.5-.5-.5Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 8.4,
    y: 2.6,
    width: 2.1,
    height: 14.8,
    rx: 0.8,
    ry: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconLicence);
export default __webpack_public_path__ + "static/media/icon_licence.54da9b5e1e4c24234420ab24fdb38443.svg";
export { ForwardRef as ReactComponent };